module.exports = __webpack_public_path__ + "img/qbert_questions_p13.dd08f5ea.jpg";